import { Component, OnInit } from '@angular/core';
import { CurrencyPipe, Location } from '@angular/common';
import { LinkService } from '../shared/services/link.service';
import { LinkInformation } from '../shared/interfaces/link-information';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-confirmation',
  standalone: true,
  imports: [CurrencyPipe],
  templateUrl: './payment-confirmation.component.html',
  styleUrl: './payment-confirmation.component.css'
})
export class PaymentConfirmationComponent implements OnInit{

  linkInfo: LinkInformation = {}

  constructor(private router: Router,private location: Location, public linkServ: LinkService){}
  
  ngOnInit(){

    this.linkInfo = this.linkServ.getLinkInformation()
  
    if(this.linkInfo.amount == undefined){
      this.goBack()
    }
  }

  goBack(): void{ 
    this.location.back();
  }

  confirm(){
    this.router.navigate(['pay/processing'])
  }
}
